// import moment from 'moment'
import moment from 'moment-timezone';

export default class Clocks {
  constructor() {
    moment.locale('en');
    const now = new Date();

    this.timezones = [
      {
        className: 'c-clock--sydney',
        time: moment.tz(now, 'Australia/Sydney'),
      },
      {
        className: 'c-clock--london',
        time: moment.tz(now, 'Europe/London'),
      },
      {
        className: 'c-clock--tokyo',
        time: moment.tz(now, 'Asia/Tokyo'),
      },
    ];

    this.timezones.forEach((timezone) => {
      const $element = document.querySelector(`.${timezone.className}`);

      if ($element) {
        this.setupClock($element, timezone.time);
      }
    });
  }

  /**
   * @function setupClock
   * @param {HTMLSVGElement} $el
   * @param {MomentTime} time
   * Creates the clock
   */
  setupClock($el, time) {
    const hands = [];
    const hour = 360 * time.hours() / 12 + time.minutes() / 2;
    const minute = 360 * time.minutes() / 60;
    const angles = [minute, hour];
    const isPM = time.format('a') === 'pm';
    const isAM = time.format('a') === 'am';
    const isNight = ((isAM && time.hours() < 6) || isPM && time.hours() > 18) ? true : false;

    if (isNight) {
      $el.classList.add('is-night');
    }

    hands.push($el.querySelector('.c-clock__minutes > *'));
    hands.push($el.querySelector('.c-clock__hours > *'));

    this.setHands(hands, angles);
  }

  /**
   * @function setHands
   * @param {Array} hands
   * @param {Array} angles
   * Sets the angle for each hand
   */
  setHands(hands, angles) {
    hands.forEach((hand, i) => {
      hand.setAttribute('from', this.constructor.shifter(angles[i]));
      hand.setAttribute('to', this.constructor.shifter(angles[i] + 360));
    });
  }

  /**
   * @function shifter
   * @param {Number} val
   */
  static shifter(val) {
    const cx = 100;
    const cy = 100;
    return [val, cx, cy].join(' ');
  }
}
